import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '{{percentage}}% de desconto em itens selecionados',
  [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '{{percentage}}% de desconto no valor total do pedido',
  [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Item gratuito com um item',
  [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Item gratuito com um valor de pedido',
  [OFFER_KIND.BOGO_HALF_PRICE]: 'Compre um leve dois a metade do preço',
  [OFFER_KIND.BOGO]: 'Compre um leve dois grátis',
  [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: '{{amount}} de desconto em itens selecionados',
  [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: '{{amount}} de desconto com um valor de pedido',
};
